import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ACCOUNT_SPLASH, HOME_SPLASH, LOAN_SPLASH } from '@core/layouts/default/default.config';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { PageRoutes } from '../../../../../app.config';

@Component({
  selector: 'shell-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {
  modalError: any;
  constructor(
    public microFrontendRouter: MicroFrontendRouter,
    private router: Router,
    private messageBusService: MessageBusService,
  ) {}

  ngOnInit(): void {
    this.emitGTM();
  }

  emitGTM() {
    this.messageBusService.emit('shell', 'google-tag-manager.event', {
      event: 'button-event',
      eventCategory: 'Complementos',
      eventAction: 'Pagina no encontrada',
      eventLabel: `Popup - ${this.router.routerState.snapshot.url}`,
    });
  }

  closeModal() {
    this.messageBusService.emit('shell', 'google-tag-manager.event', {
      event: 'button-event',
      eventCategory: 'Complementos',
      eventAction: 'Pagina no encontrada',
      eventLabel: 'Volver al inicio',
    });
    this.validateRouter();
  }

  validateRouter(): void {
    //currentRoute get the always the second split (abrir-cuenta or prestamo-personal) of the current route
    const currentRoute = this.router.url.split('/')[1];
    //routeHome redirect to route find map or splash
    let routeHome = PageRoutes.get(currentRoute)?.route || HOME_SPLASH;
    if (this.router.url.indexOf(ACCOUNT_SPLASH) >= 0 || this.router.url.indexOf(LOAN_SPLASH) >= 0) {
      routeHome = HOME_SPLASH;
    }

    this.microFrontendRouter.navigateByUrl(`/${routeHome}`, routeHome);
    window.location.href = window.location.origin;
  }
}
